module.exports = __webpack_public_path__ + "img/andrey-malykh-untitled.ab70086.jpg";